import React, { Component } from 'react';
import he from 'he';
import Cell from '../DesktopProducts/Cell';
import Property from '../Property';
import { normalizeProductValue, isCategoryRowHighlighted } from '../../utils';
import styles from '../PropertyRow/index.module.scss';
import { ProductsParametersApi } from '@pes-ui/utils/lib/types/api/products-parameters-api';
import { MappedProduct } from '../../utils/mappers';

type Props = {
    products: MappedProduct[];
    category: ProductsParametersApi.Section;
    value: string;
    highlightDifferences: boolean;
    isRowHighlighted: ProductsParametersApi.SectionParameter['hidable'];
    isHorizontalScroll: boolean;
    linkClickHandlerCallback?: (link: string) => void;
};

type State = {
    minCellHeight: number;
    calculatedRunTimeValue: string;
}
const labelCellValueWrapRef = React.createRef<HTMLDivElement>();

class PropertyRow extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            minCellHeight: null,
            calculatedRunTimeValue: '',
        };
    }

    updateRowHeight() {
        const cellValueWrapper = labelCellValueWrapRef.current;

        if (cellValueWrapper) {
            const labelValueHeight = cellValueWrapper.getBoundingClientRect().height;
            const { minCellHeight } = this.state;

            if (minCellHeight === null || minCellHeight !== labelValueHeight) {
                this.setState({ minCellHeight: labelValueHeight });
            }
        }
    }

    componentDidMount() {
        this.updateRowHeight();
    }

    componentDidUpdate() {
        this.updateRowHeight();
    }

    handleRunTimeInputChange = value => {
        if (!value.match(/[^0-9]|^0{1}/g)) {
            this.setState({
                calculatedRunTimeValue: value,
            });
        }
    };

    render() {
        const { products, category, value, highlightDifferences, isRowHighlighted, isHorizontalScroll, linkClickHandlerCallback } = this.props;
        const { minCellHeight } = this.state;

        return (
            <div className="row flex-row flex-nowrap no-gutters" data-row-name={value}>
                <Cell
                    labelCol
                    isHorizontalScroll={isHorizontalScroll}
                >
                    <div className={styles.groupParameter}>
                        <div
                            ref={labelCellValueWrapRef}
                            className={styles.cellValueWrap}
                            role="rowheader"
                        >
                            {/* Decode categoryParameterValue (decoding unicode characters) */}
                            {he.decode(category.parameters[value].label)}
                        </div>
                    </div>
                </Cell>
                {products.map((prod, i) => {
                    //productCategories add in prod in mappers from GetProductsParametersResponse
                    const productCategories = normalizeProductValue(prod.productCategories, value);
                    return (
                        <Cell
                            key={`${prod.productId}-${i}`}
                            highlightDifferences={
                                isCategoryRowHighlighted(value, isRowHighlighted) &&
                                highlightDifferences
                            }
                        >
                            <div
                                style={{ minHeight: minCellHeight ? `${minCellHeight}px` : 'auto' }}
                                data-product-id={prod.productId}
                            >
                                {productCategories.map(
                                    (
                                        { productUrl, productValue, hasExternalLink, chartLabel, openPopupList },
                                        index,
                                    ) => (
                                        <Property
                                            key={`${productValue}-${prod.productId}-${index}`}
                                            productUrl={productUrl}
                                            productValue={productValue}
                                            hasExternalLink={hasExternalLink}
                                            openPopupList={!!openPopupList}
                                            chartLabel={chartLabel}
                                            linkClickHandlerCallback={linkClickHandlerCallback}
                                        />
                                    ),
                                )}
                            </div>
                        </Cell>
                    );
                })}
            </div>
        );
    }
}

export default PropertyRow;
